import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
    },
    paper: {
      padding: theme.spacing(3),
      borderRadius: theme.spacing(1),
    },
    boxTop: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(3),
      flexWrap: 'wrap',
      gap: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    sectionTitle: {
      marginLeft: theme.spacing(2),
      flex: 1,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        order: 2,
      },
    },
    addButton: {
      [theme.breakpoints.down('sm')]: {
        order: 3,
        alignSelf: 'stretch',
      },
    },
    noResults: {
      textAlign: 'center',
      padding: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(4),
    },
  })
);

export default useStyles;